import { createSlice } from '@reduxjs/toolkit';

// Get user from cookies on initialization
const getUserFromCookies = () => {
  if (typeof window !== 'undefined') {
    try {
      const userDataCookie = document.cookie
        .split('; ')
        .find(row => row.startsWith('userData='));
      
      if (userDataCookie) {
        const userData = decodeURIComponent(userDataCookie.split('=')[1]);
        return JSON.parse(userData);
      }
    } catch (error) {
      console.error('Error reading user from cookies:', error);
    }
  }
  return null;
};

const initialState = {
  user: getUserFromCookies(),
  isAuthenticated: !!getUserFromCookies(),
  loading: false,
  error: null,
};

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setLoading: (state, action) => {
      state.loading = action.payload;
      state.error = null;
    },
    loginSuccess: (state, action) => {
      state.user = action.payload;
      state.isAuthenticated = true;
      state.loading = false;
      state.error = null;
    },
    loginFailure: (state, action) => {
      state.user = null;
      state.isAuthenticated = false;
      state.loading = false;
      state.error = action.payload;
    },
    logout: (state) => {
      state.user = null;
      state.isAuthenticated = false;
      state.loading = false;
      state.error = null;
    },
    updateProfile: (state, action) => {
      state.user = { ...state.user, ...action.payload };
      
      // Update cookie with new user data
      if (typeof window !== 'undefined') {
        const expires = new Date(Date.now() + 24 * 60 * 60 * 1000).toUTCString();
        document.cookie = `userData=${encodeURIComponent(JSON.stringify(state.user))}; expires=${expires}; path=/; sameSite=lax`;
      }
    },
    setUser: (state, action) => {
      // This action is for updating user from cookies/middleware
      state.user = action.payload;
      state.isAuthenticated = !!action.payload;
    },
    clearError: (state) => {
      state.error = null;
    },
  },
});

export const {
  setLoading,
  loginSuccess,
  loginFailure,
  logout,
  updateProfile,
  setUser,
  clearError,
} = userSlice.actions;

export default userSlice.reducer;